import { render, staticRenderFns } from "./CopyrightBar.vue?vue&type=template&id=1d13218f&"
import script from "./CopyrightBar.vue?vue&type=script&lang=js&"
export * from "./CopyrightBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports